// Ability registry. New abilities: write a file, import it here, register it.

import type { AbilityId } from "../../data/champions";
import type { Ability } from "./Ability";
import { ahriOrb } from "./AhriOrb";
import { alistarPulverize } from "./AlistarPulverize";
import { ezrealMysticShot } from "./EzrealMysticShot";
import { garenJudgment } from "./GarenJudgment";
import { illaoiTentacle } from "./IllaoiTentacle";
import { jarvanCataclysm } from "./JarvanCataclysm";
import { khazixLeap } from "./KhazixLeap";
import { leonaShield } from "./LeonaShield";
import { masterYiAlphaStrike } from "./MasterYiAlphaStrike";
import { olafRagnarok } from "./OlafRagnarok";
import { blitzcrankHook } from "./BlitzcrankHook";
import { blitzcrankPunch } from "./BlitzcrankPunch";
import { katarinaDeathLotus } from "./KatarinaDeathLotus";
import { karthusRequiem } from "./KarthusRequiem";
import { asheVolley } from "./AsheVolley";
import { chogathRupture } from "./ChoGathRupture";
import { jaxCounterStrike } from "./JaxCounterStrike";
import { mundoUlt } from "./MundoUlt";
import { sorakaWish } from "./SorakaWish";
import { taricDazzle } from "./TaricDazzle";
import { luxFinalSpark } from "./LuxFinalSpark";
import { yorickSummonGhoul } from "./YorickSummonGhoul";
import { kaisaUlt } from "./KaisaUlt";
import { nasusSiphoning } from "./NasusSiphoning";
import { jinxFishbones } from "./JinxFishbones";
import { lissandraIceTomb } from "./LissandraIceTomb";
import { viktorDeathRay } from "./ViktorDeathRay";
import { fioraRiposte } from "./FioraRiposte";
import { malphiteUltimate } from "./MalphiteUltimate";
// New abilities
import { tryndamereBloodlust } from "./TryndamereBloodlust";
import { sylasChains } from "./SylasChains";
import { dariusApprehend } from "./DariusApprehend";
import { vladimirTransfusion } from "./VladimirTransfusion";
import { dravenSpinning } from "./DravenSpinning";
import { viVaultBreaker } from "./ViVaultBreaker";
import { caitlynPeacemaker } from "./CaitlynPeacemaker";
import { jayceMercuryHammer } from "./JayceMercuryHammer";
import { renektonDominus } from "./RenektonDominus";
import { sivirRicochet } from "./SivirRicochet";
import { xerathArcaneBarrage } from "./XerathArcaneBarrage";
import { azirSoldier } from "./AzirSoldier";
import { pantheonShield } from "./PantheonShield";
import { zoeSleepyTrouble } from "./ZoeSleepyTrouble";
import { aurelionStarfire } from "./AurelionStarfire";
import { yuumiHeal } from "./YuumiHeal";
import { nidaleeJavelin } from "./NidaleeJavelin";
import { neekoBounceQ } from "./NeekoBounceQ";

const registry = new Map<AbilityId, Ability>();

function register(ability: Ability): void {
  registry.set(ability.id, ability);
}

register(ahriOrb);
register(alistarPulverize);
register(ezrealMysticShot);
register(garenJudgment);
register(illaoiTentacle);
register(jarvanCataclysm);
register(khazixLeap);
register(leonaShield);
register(masterYiAlphaStrike);
register(olafRagnarok);
register(blitzcrankHook);
register(blitzcrankPunch);
register(katarinaDeathLotus);
register(karthusRequiem);
register(asheVolley);
register(chogathRupture);
register(jaxCounterStrike);
register(mundoUlt);
register(sorakaWish);
register(taricDazzle);
register(luxFinalSpark);
register(yorickSummonGhoul);
register(kaisaUlt);
register(nasusSiphoning);
register(jinxFishbones);
register(lissandraIceTomb);
register(viktorDeathRay);
register(fioraRiposte);
register(malphiteUltimate);
// New abilities
register(tryndamereBloodlust);
register(sylasChains);
register(dariusApprehend);
register(vladimirTransfusion);
register(dravenSpinning);
register(viVaultBreaker);
register(caitlynPeacemaker);
register(jayceMercuryHammer);
register(renektonDominus);
register(sivirRicochet);
register(xerathArcaneBarrage);
register(azirSoldier);
register(pantheonShield);
register(zoeSleepyTrouble);
register(aurelionStarfire);
register(yuumiHeal);
register(nidaleeJavelin);
register(neekoBounceQ);

export function getAbility(id: AbilityId): Ability {
  const ability = registry.get(id);
  if (!ability) throw new Error(`Ability not registered: ${id}`);
  return ability;
}

export function hasAbility(id: AbilityId): boolean {
  return registry.has(id);
}

export { type Ability, type AbilityContext, type AbilityHit } from "./Ability";
